'use client';

import {
    HorizontalOverflowCarousel,
    HorizontalOverflowCarouselItem,
    LayoutContainer,
    ProductCard,
    Section,
} from '@petsmart-ui/sparky';

import { transformHitForProductTile } from '@libs/algolia';
import { type Product, useOptimizely } from '@libs/common-next';
import { useOptexBiaGuest } from '@libs/contentful';
import './optex-homepage-bia-guest.scss';

const OPTEX_HOMEPAGE_BIA_GUEST_CALLER = 'web:homepage:bia-guest';
const OPTEX_BIA_SEARCH_CLICK_ENGAGEMENT_EVENT = '_us_ca__bia_search_click_engagement__fxe___global___s___1085_';

export function OptexHomepageBiaGuestCarousel() {
    const { context } = useOptimizely();
    const { data: optexProducts = [], isError } = useOptexBiaGuest({
        optexEnabled: true,
        optexPlacement: 'homepage',
        optexCaller: OPTEX_HOMEPAGE_BIA_GUEST_CALLER,
    });

    if (isError || !optexProducts.length) return null;

    return (
        <LayoutContainer className="optex-homepage-bia-guest" data-testid="optex_homepage_bia">
            <Section headingTagName="h2" title="Most-loved essentials" align="center">
                <HorizontalOverflowCarousel
                    className="optex-homepage-bia-guest__carousel"
                    perViewDefault={6}
                    defaultGap={32}
                    breakpoints={{
                        1200: { perView: 6, gap: 32 },
                        560: { perView: 2.5, gap: 8 },
                    }}
                >
                    {optexProducts.map(({ sku, hit }, optexIndex) => {
                        const { id: _id, ...optexProductData } = transformHitForProductTile(hit) as Product;
                        return (
                            <HorizontalOverflowCarouselItem key={`${sku}-${optexIndex}`}>
                                <ProductCard
                                    {...optexProductData}
                                    imgSrc={hit.images?.large ?? hit.images?.small}
                                    onClick={() => context?.trackEvent(OPTEX_BIA_SEARCH_CLICK_ENGAGEMENT_EVENT)}
                                />
                            </HorizontalOverflowCarouselItem>
                        );
                    })}
                </HorizontalOverflowCarousel>
            </Section>
        </LayoutContainer>
    );
}
